import config from 'config';
import store from '../store';
import * as types from '../actions/winner-actions';

import dbInstance from './dbInstace';

class WinnerApi {

	/**
	 * Get winners from cms api
	 * @returns {Promise<T>}
	 */
	static getWinners() {

		return dbInstance.get(config.core.API.routes.winner).then(response => {
			console.debug(response);

			store.dispatch({
				type: types.GET_WINNER_SUCCESS,
				winner: response
			});

			return response;
		}).catch(err => {
			console.info(err);

			store.dispatch({
				type: types.GET_WINNER_ERROR,
				error: err
			});

			return err;
		});

	}
}

export default WinnerApi;


// WEBPACK FOOTER //
// ./src/api/winner-api.js